<template>
  <div class="footerC"
       v-bind:class="{ isDetail:isDetail}">技术支持：阿中软件</div>
</template>
<script>
export default {
  name: "footerC",
  props: {
    isDetail: {
      type: Boolean,
      default: false
    }
  },
};
</script>
<style lang="less">
.footerC {
  width: 100%;
  text-align: center;
  line-height: 60px;
  position: fixed;
  bottom: 0px;
  color: #fff;
  font-size: 14px;
  letter-spacing: 1px;
}
.footerC.isDetail {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/FooterC/footerC.vue